import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import Histogram from '../../insights/Histogram';

export const ActivityByDay = ({ story, action, isPaused, config, storyData }) => {
    const dayNames = {
        'Sun': 'Sunday',
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday'
    }
    const mostActiveDays = storyData.data.mostActiveDays; // this is an array of tuples like [['Sun', 2]]
    const getHeading = () => {
        if (mostActiveDays.length === 1) {
            return `You tuned in the most on ${dayNames[mostActiveDays[0][0]]}`;
        }
        else if (mostActiveDays.length === 2) {
            return `${dayNames[mostActiveDays[0][0]]} and ${dayNames[mostActiveDays[1][0]]} were particularly reflective`;
        }
        else {
            return `Your rhythm of checking in`;
        }
    }

    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2} style={{ position: "absolute", top: "5rem" }}>
                {getHeading()}
            </h1>
            <Histogram data={storyData.data.activityLevels} />
        </StoryWrapper>
    );
};